<ion-header>
  <app-header></app-header>
  <ion-grid class="header-container head-block">
    <!-- Header View -->
    <div class="flex-container available-width"
      [ngClass]="prjDetailSelectedSegment !== 'projectInformation_segment' && !IsEmptyCard ? 'available-width':
      prjDetailSelectedSegment === 'status_segment' && IsEmptyCard ? 'reduce-header-width' :prjDetailSelectedSegment === 'overview_segment' && IsEmptyCard ? 'reduce-header-width' : '' ">
      <div class="left-column">
        <app-exit-button class="left-margin" (click)="goBack()"></app-exit-button>
      </div>
      <div class="right-column">
        <div tabindex="0" role="button" (keydown.enter)="openProjectAction($event,'openProAction')" class="header-right header-top hov-label" (click)="openProjectAction($event,'openProAction')">
          {{ 'Project Actions' | translate}} <img src="../../../assets/images/Down_Arrow.svg"
            class="header-dropdown-arrow" alt="">
        </div>
        <div tabindex="0" role="button" (keydown.enter)="openProjReport($event,'openProReport', projectList?.status,prodetailsData.selectOrder,prodetailsData.serviceType,projectList.project_Id,projectList?.erp_Project_Id,projectList?.company_Code,projectList?.project_Name, projectList.is_sap)" class="header-right header-top hov-label" (click)="openProjReport($event,'openProReport', projectList?.status,prodetailsData.selectOrder,prodetailsData.serviceType,projectList.project_Id,projectList?.erp_Project_Id,projectList?.company_Code,projectList?.project_Name, projectList.is_sap)">
          {{ 'Project Report' | translate}} <img src="../../../assets/images/Down_Arrow.svg"
            class="header-dropdown-arrow" alt="">
        </div>
        <div tabindex="0" role="button" (keydown.enter)="openStatusPopover($event,'projectInformationStatus',projectList?.status)" (click)="openStatusPopover($event,'projectInformationStatus',projectList?.status)">
          <ion-icon color="primary" tooltip="{{'More actions' | translate }}" placement="bottom" name="ellipsis-vertical-outline" class="header-more-icon"></ion-icon>
        </div>
      </div>
    </div>

    <!-- Select Job Order & Service Product Id Options View -->
    <ion-row class="alignrow">
      <!--if isFromSAP is true then job order selection will be displayed-->
      <ng-container *ngIf="isFromSAP">
        <ion-col  size-xs='1.3' size-sm='1.3' size-md="1.3" size-lg="1.3" size-xl="1.3" style="margin-top: 4px;">
          <ion-label class="sd-label">
            {{ 'Select Job Order' | translate}}
          </ion-label>
        </ion-col>
        <ion-col  size-xs='2' size-sm='2' size-md="2" size-lg="2" size-xl="2">
          <ng-select class="dropdown" [disabled]="selectServiceOrderOptions.length === 0" [clearable]="false" [items]="selectServiceOrderOptions"
            [(ngModel)]="prodetailsData.selectOrder" bindLabel="erp_Order_Id" bindValue="erp_Order_Id"
            placeholder="{{'Select Job Order Id'|translate}}" (change)="selectJobOrderId($event)">
          </ng-select>
        </ion-col>
        <!-- Service Product Id Selection -->
        <ion-col size-xs='0.8' size-sm='0.8' size-md="1" size-lg="1" size-xl="1" style="margin-top: 4px;">
          <ion-label class=" sd-label">
            {{ 'Service Id' | translate}}
          </ion-label>
        </ion-col>
        <ion-col size-xs='2' size-sm='2' size-md="2" size-lg="2" size-xl="2">
          <ng-select class="dropdown" name="clientCustomerId" [clearable]="false"
            placeholder="{{'Select Service Id'|translate}}" [items]="serviceTypesList"
            [(ngModel)]="prodetailsData.serviceType" bindLabel="service_Type" bindValue="service_Type"
            (change)="selectServiceType($event)" (focus)="getServiceTypeByOrderId(prodetailsData.selectOrder)"
            [disabled]="prodetailsData.selectOrder || selectServiceOrderOptions.length !== 0 ? false : true">
          </ng-select>
        </ion-col>
      </ng-container>
      <ng-container *ngIf="!isFromSAP">
        <!-- Service Product Id Selection -->
        <ion-col size-xs='0.8' size-sm='0.8' size-md="0.8" size-lg="0.8" size-xl="0.8" style="margin-top: 4px;">
          <ion-label class=" sd-label">
            {{ 'Service Id' | translate}}
          </ion-label>
        </ion-col>
        <ion-col size-xs='2' size-sm='2' size-md="2" size-lg="2" size-xl="2">
          <ng-select placeholder="{{ 'Select Service Id' | translate}}"
            (change)="selectServiceId($event,selectedServiceIdNonSAP)" 
            [(ngModel)]="selectedServiceIdNonSAP" [clearable]="false"
            [disabled]="!selectedServiceIdNonSAP" >
            <ng-option *ngFor="let service of serviceIds" [value]="service"
            >{{service}}</ng-option>
          </ng-select>
        </ion-col>
      </ng-container>
    </ion-row>
  </ion-grid>

  <!-- Segment View -->
  <div class="card-container-block">
    <div class="tabs">
      <div class="tab-option" [class.active]="activeTab === tabs.PROJECT_OVERVIEW"
                   role="tab"
                   tabindex="0"
                   [attr.aria-selected]="activeTab === tabs.PROJECT_OVERVIEW"
                   (click)="segmentChanged('projectInformation_segment')"
                   (keydown)="onSegmentTabKeydown($event, 'projectInformation_segment', false)">
        {{ 'Project Overview' | translate}}</div>  
      <div class="tab-option" 
        [class.disabled]="prodetailsData.serviceType === null && selectedServiceIdNonSAP === ''" 
        [class.active]="activeTab === tabs.PROJECT_SERVICE_DETAILS"
        role="tab"
        [tabindex]="(prodetailsData.serviceType === null && selectedServiceIdNonSAP === '') ? -1 : 0"
        [attr.aria-disabled]="prodetailsData.serviceType === null && selectedServiceIdNonSAP === ''"
        [attr.aria-selected]="activeTab === tabs.PROJECT_SERVICE_DETAILS"
        (click)="segmentChanged('service_details_segment')"
        (keydown)="onSegmentTabKeydown($event, 'service_details_segment', prodetailsData.serviceType === null && selectedServiceIdNonSAP === '')">
        {{ 'Service Details' | translate}}</div>      
      <!-- <div class="tab-option" 
        [class.disabled]="(serviceDetails?.is_machinebased == true || prodetailsData.serviceType==null || machineListInfo.length != 0 )"
        [class.active]="activeTab === tabs.SERVICE_ROADMAP_DETAILS"
        (click)="segmentChanged('service_roadmap_details_segment')">
        {{ 'Service Roadmap Details' | translate}}</div>     -->
      <div class="tab-option" 
        [class.disabled]="isMachineDetailsTabDisabled" 
        [class.active]="activeTab === tabs.MACHINE_DETAILS"
        role="tab"
        [tabindex]="isMachineDetailsTabDisabled ? -1 : 0"
        [attr.aria-disabled]="isMachineDetailsTabDisabled"
        [attr.aria-selected]="activeTab === tabs.MACHINE_DETAILS"
        (click)="segmentChanged('machine_details_segment')"
        (keydown)="onSegmentTabKeydown($event, 'machine_details_segment', isMachineDetailsTabDisabled)">
     {{ 'Machine Details' | translate }}
   </div>
   
      <div class="tab-option" *ngIf="isFromSAP"
        [class.disabled]="prodetailsData.selectOrder === null && prodetailsData.serviceType === null"
        [class.active]="activeTab === tabs.LOG_ACTUAL_HOURS"
        role="tab"
        [tabindex]="(prodetailsData.selectOrder === null && prodetailsData.serviceType === null) ? -1 : 0"
        [attr.aria-disabled]="prodetailsData.selectOrder === null && prodetailsData.serviceType === null"
        [attr.aria-selected]="activeTab === tabs.LOG_ACTUAL_HOURS"
        (click)="segmentChanged('log_actual_hours_segment')"
        (keydown)="onSegmentTabKeydown($event, 'log_actual_hours_segment', prodetailsData.selectOrder === null && prodetailsData.serviceType === null)">
        {{ 'Log Actual Hours' | translate}}</div>  
      <!-- Disabling Projects Items View as there is no data to show-->   
      <!-- <div class="tab-option"         
        [class.active]="activeTab === tabs.PROJECT_ITEMS_VIEW"
        (click)="segmentChanged('overview_segment')">
        {{ 'Project Items View' | translate}}</div>    -->
    </div>
  </div>  
</ion-header>
<ion-content fullscreen="true" no-bounce [scrollEvents]="true">
  <div [ngSwitch]="prjDetailSelectedSegment" class="pd-segment-container">
    <!-- Project Information -->
    <div *ngSwitchCase="'projectInformation_segment'" class="margin-left-110">
      <ion-grid>
        <ion-row>
          <ion-col size="6">
            <ion-card class="innercard">
              <ion-card-header>
                <ion-card-title class="pdsc-title">{{ 'Project Details' | translate}}
                </ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <ion-row>
                  <ion-col size="7">
                    <ion-label class="pdsc-label">{{ 'Project Name' | translate}} </ion-label><br />
                    <p class="pdscl-value">{{projectList?.project_Name}}</p>
                  </ion-col>
                  <ion-col size="4">
                    <ion-label class="pdsc-label">{{ 'Project Id' | translate}} </ion-label><br />
                    <p class="pdscl-value">
                      {{projectList?.erp_Project_Id?projectList?.erp_Project_Id:projectList?.project_Id}}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="7">
                    <ion-label class="pdsc-label">{{ 'Customer Name' | translate}} </ion-label><br />
                    <p class="pdscl-value">{{projectList?.customer_Name}}</p>
                  </ion-col>
                  <ion-col size="4">
                    <ion-label class="pdsc-label">{{ 'Company Code' | translate}} </ion-label><br />
                    <p class="pdscl-value">{{projectList?.companyCodeAndCompanyName}}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="7">
                    <ion-label class="pdsc-label">{{ 'Status' | translate}} </ion-label><br />
                    <p class="pdscl-value">{{projectList?.status}}</p>
                  </ion-col>
                  <ion-col size="4">
                    <ion-label class="pdsc-label">{{ 'Description' | translate}} </ion-label><br />
                    <p class="pdscl-value" [title]="projectList?.description">
                      {{ projectList?.description | slice:0:35 }}{{ projectList?.description?.length > 15 ? '...' : '' }}
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="7">
                    <ion-label class="pdsc-label">{{ 'Project Start Date' | translate}} </ion-label><br />
                    <p class="pdscl-value">{{ formatDisplayDate(projectList?.start_Date) }}</p>
                  </ion-col>
                  <ion-col size="4">
                    <ion-label class="pdsc-label">{{ 'Project End Date' | translate}} </ion-label><br />
                    <p class="pdscl-value">{{ formatDisplayDate(projectList?.end_Date) }}</p>
                  </ion-col>
                </ion-row>
              </ion-card-content>
            </ion-card>
          </ion-col>
          <ion-col size="6">
            <ion-card class="innercard" style="width:97%!important;">
              <ion-card-header>
                <ion-card-title class="pdsc-title">{{ 'Budget and Costing Information' | translate}} </ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <ion-row>
                  <ion-col size="6">
                    <ion-label class="pdsc-label">{{ 'Project Budget' | translate}} </ion-label><br />
                    <p class="pdscl-value">{{projectList?.projectBudget}}</p>
                  </ion-col>
                  <ion-col size="6">
                    <ion-label class="pdsc-label">{{ 'Actual Cost' | translate}} </ion-label><br />
                    <p class="pdscl-value">{{projectList?.actualCost}}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="6">
                    <ion-label class="pdsc-label">{{ 'Total Number Of Questions' | translate}}</ion-label><br />
                    <p class="pdscl-value" *ngIf="projectList?.time">{{projectList?.totalStepCount}}
                    </p>
                  </ion-col>
                  <ion-col size="6">
                    <ion-label class="pdsc-label">{{ 'Total Number Of Open Questions' | translate}}</ion-label><br />
                    <p class="pdscl-value">{{projectList?.totalStepCount-projectList?.totalAnswredStepCount}}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="6">
                    <ion-label class="pdsc-label">{{ 'Total Number Of Calculated Hours' | translate}}</ion-label><br />
                    <p class="pdscl-value" *ngIf="projectList?.time">{{projectList?.totlalCalculatedHours}} h
                    </p>
                  </ion-col>
                  <ion-col size="6">
                    <ion-label class="pdsc-label">{{ 'Total Number Of Actual Hours' | translate}}</ion-label><br />
                    <p class="pdscl-value">{{projectList?.totalActualHours}} h</p>
                  </ion-col>
                </ion-row>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <ion-card class="innercard pdsc-card-extra-space">
              <ion-card-header>
                <ion-card-title class="pdsc-title">{{ 'Customer Details' | translate}} </ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <ion-row>
                  <ion-col size="4">
                    <ion-label class="pdsc-label">{{ 'Customer Name' | translate}}</ion-label><br />
                    <p class="pdscl-value">{{projectList?.customerDetails.customer_Name}}</p>
                  </ion-col>
                  <ion-col size="4">
                    <ion-label class="pdsc-label">{{ 'Customer Contact' | translate }}</ion-label><br />
                    <p class="pdscl-value">{{projectList?.customerDetails.phone_Number}}</p>
                  </ion-col>
                  <ion-col size="4">
                    <ion-label class="pdsc-label">{{ 'Customer Address' | translate}} </ion-label><br />
                    <p class="pdscl-value"> {{projectList?.customerDetails.address}}</p>
                  </ion-col>
                </ion-row>
              </ion-card-content>

              <ion-card-header>
                <ion-card-title class="pdsc-title">{{ 'Contact Details' | translate}} </ion-card-title>
              </ion-card-header>
              <ion-card-content *ngFor="let contact of projectList?.customerDetails.contacts">
                <ion-row>
                  <ion-col size="4">
                    <ion-label class="pdsc-label">{{ 'Contact Person' | translate}} </ion-label><br />
                    <p class="pdscl-value">{{contact?.display_name ? contact?.display_name : contact.first_name  + ' ' + contact.last_name}}</p>
                  </ion-col>
                  <ion-col size="4">
                    <ion-label class="pdsc-label">{{ 'Contact Number' | translate}} </ion-label><br />
                    <p class="pdscl-value">{{contact.phone_number}}</p>
                  </ion-col>
                  <ion-col size="4">
                    <ion-label class="pdsc-label">{{ 'Contact Email' | translate}} </ion-label><br />
                    <p class="pdscl-value">{{contact.email_address}}</p>
                  </ion-col>
                </ion-row>
              </ion-card-content>
            </ion-card>
          </ion-col>
          <ion-col size="6">
            <ion-card class="innercard pdsc-card-extra-space" style="width:97%!important;">
              <div class="flex-container card-top-margin">
                <div class="left-column">
                  <ion-card-title style="margin-left:1rem!important" class="pdsc-title">{{ 'Assigned Staff' |
                    translate}} </ion-card-title>
                </div>
                <div class="right-column">
                  <img tabindex="0" role="button" tooltip="{{'Add user' | translate }}" alt="" placement="top" class="add-user" (keydown.enter)="goToAddAssignedStaff('assignProject')" (click)="goToAddAssignedStaff('assignProject')" src="../../../assets/icon/add_user.svg" />
                </div>
              </div>
                <ion-row class="pdsc-user-info">
                  <ng-container *ngFor="let contact of assignedStaffList; let i = index">
                    <!-- Start a new row for every 2 items -->
                    <ng-container *ngIf="i % 2 === 0">
                      <ion-row class="pdsc-user-info-row"> </ion-row>
                    </ng-container>
                  <ion-col size="6" >
                    <ion-card class="pdscui-card-container">
                      <div class="staff-flex-container">
                        <div class="left-column">
                         <img [src]="contact?.userImage === '' || contact?.userImage === null ? '../../../assets/Profile_Potrait.svg' : contact.userImage"  class="pdscui-card-badge" alt="">                          
                          <div class="pdscui-card-title">
                            <span>{{contact.firstName+ ' ' +contact.LastName | ellipsis: 30}}</span>
                            <br />
                            <p class="pdscui-card-sub-title">{{ contact.userRole | ellipsis: 20 }}</p>
                          </div>
                        </div>
                        <div class="right-column">
                          <ion-icon tabindex="0" role="button" class="pdscui-card-del-img delete-icon-transition" name="trash-outline" tooltip="{{'Delete user' | translate }}"
                            placement="bottom" (keydown.enter)="deleteStaffConfirmation(contact.emailAdd,contact)" (click)="deleteStaffConfirmation(contact.emailAdd,contact)">
                          </ion-icon>
                        </div>
                      </div>
                    </ion-card>
                  </ion-col>
                  <ng-container *ngIf="(i === assignedStaffList.length - 1) || (i % 2 === 1)">
                </ng-container>
              </ng-container>
                </ion-row>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <!-- Machine Details Segemnt -->
    <div *ngSwitchCase="'machine_details_segment'" class="margin-left-110">
      <ng-container *ngIf="IsEmptyCard">
        <div class="available-width">
          <ion-grid>
            <ion-row class="labelside">
              <ion-col size='12' style="text-align: end;">
                
                <ion-col size='2' style="margin-right: 0.2em;">
                  <img src="../../../assets/images/Approve.svg" class="source" alt="">
                  <button class="sourLabel bucket-button" (focus)="scrollMachineBucketControlsIntoView()" [disabled]="!isAnyMachineListSelected"
                    [ngClass]="!isAnyMachineListSelected ? 'disable-button' : 'active-button'" (click)="addToBucket()">
                    {{ 'Add to Bucket' | translate}}
                  </button>
                </ion-col>
                <!-- <ion-col class="conflict-button" size='2'>
                  <button [ngClass]="(isConflictInAnyMachine&&isConflictResolutionPermission) ? 'active-button' : ''"
                    [disabled]="!isConflictInAnyMachine && !isConflictResolutionPermission"
                    (click)="goToConflictResolutionPage()">
                    <img src="../../../assets/images/Approve.svg" class="source" alt="">
                    <ion-label class="sourLabel"> {{ 'Conflicts' | translate}}</ion-label>
                  </button>
                </ion-col> -->

                <ion-col size='4'>
                  <button class="butCreate" (focus)="scrollMachineBucketControlsIntoView()" (click)="myMachineAddBucket($event, 'machineSegmentBuckesEditOrCreate')">
                    <label class="crLabel"> {{ 'Buckets' | translate}}</label>
                    <img src="../../../assets/images/Down_Arrow.svg" class="insideImage" alt="">
                  </button>
                </ion-col>
                <!-- commented till approval of removing list view functionality completely -->
                <!-- <ion-col size='0.8'>
                  <img src="../../../assets/images/List_View.svg" class="source text-hover"
                    (click)="changeMachineListView('layout')" alt="">
                </ion-col>
                <ion-col size='0.8'>
                  <img src="../../../assets/images/Grid_View.svg" class="source text-hover"
                    (click)="changeMachineListView('grid')" alt="">
                </ion-col> -->
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>

        <!-- Added Bucket & All Machine Lists -->
        <div class="available-width">
          <!-- Machines Added To Bucket -->
          <ng-container *ngIf="allBucketLists?.length && (isBucketListPermission || isBucketWritePermission)">
            <ion-card class="card-header">
              <ion-label class="titlelabel" style="padding-left: 2em;"> {{ 'All Buckets' | translate}}</ion-label>
              <div *ngFor="let bucket of allBucketLists">
                <ion-card (focus)="scrollMachineBucketControlsIntoView()" (keydown.enter)="changeServiceTypeSelection(bucket)" tabindex="0"  class="list-card">
                  <ion-item lines='none' class="service-type-list mainlabel"
                      (click)='changeServiceTypeSelection(bucket)'>
                    <ion-label class="bucket-sub-title">{{bucket.Bucket_Name}}</ion-label>
                    <ion-icon name="chevron-down-outline" slot="end" *ngIf="!bucket?.opened"></ion-icon>
                    <ion-icon name="chevron-up-outline" slot="end" *ngIf="bucket?.opened"></ion-icon>
                  </ion-item>
                  <div *ngIf="bucket?.opened">
                    <ng-container *ngIf="bucket.machines?.length">
                      <ion-grid *ngIf="machineListViewType === 'grid-view' ">
                        <ion-row class="labelside">
                          <ion-col size='3' *ngFor="let machine of bucket.machines">
                            <app-machine-card [item]="machine" [showStatus]="true" [status]="machine.is_RA_Status" [showMore]="true" [showCheckbox]="false"
                              *ngIf='machine.machine_Id!=="00000000-0000-0000-0000-000000000000"'
                              (deleteMachineCheckbox)="changeMachineCheckboxSelection($event)" (checkMore)="machineMoreIcons($event, 'bucket-machine-specific-kebab-elipse', machine,bucket)"
                              id="gridView_bucket_added_machine_{{machine.machine_Id}}" (click)="goToMachineDetails($event, machine)">
                            </app-machine-card>                             
                          </ion-col>
                        </ion-row>
                      </ion-grid>
                      <ion-grid *ngIf="machineListViewType === 'layout-view' ">
                        <ion-row class="labelside">
                          <ion-col>
                            <label class="lableFont"> {{ 'Machine Name' | translate}}</label>
                          </ion-col>
                          <ion-col>
                            <label class="lableFont"> {{ 'Serial Number' | translate}}</label>
                          </ion-col>
                          <ion-col>
                            <label class="lableFont"> {{ 'Asset No.' | translate}}</label>
                          </ion-col>
                          <ion-col>
                            <label class="lableFont"> {{ 'Machine Type' | translate}}</label>
                          </ion-col>
                          <ion-col><label class="lableFont"> {{ 'Assigned Staff' | translate}}</label></ion-col>
                        </ion-row>
                        <ion-row class="borderdown"></ion-row>
                        <div *ngFor="let machine of bucket.machines">
                          <ion-row class="labelside" *ngIf='machine.machine_Id!=="00000000-0000-0000-0000-000000000000"'
                            (click)="goToMachineDetails($event, machine)"
                            id="listView_bucket_added_machine_{{machine.machine_Id}}">
                            <ion-col>
                              <label class="lablemain">
                                {{machine.Machine_Name}}
                              </label>
                            </ion-col>
                            <ion-col>
                              <label class="lableSub">{{machine.Serial_Number ? machine.Serial_Number :
                                '-'}}</label>
                            </ion-col>
                            <ion-col>
                              <label class="lableSub"> {{machine.Asset_Id ? machine.Asset_Id : '-'}} </label>
                            </ion-col>
                            <ion-col>
                              <label class="lableSub"> {{machine.masterMachine?.machine_Type?
                                machine.masterMachine?.machine_Type : '-'}} </label>
                            </ion-col>
                            <ion-col>
                              <label class="lableSub"> {{machine.assignedStaff?.display_Name?
                                machine.assignedStaff?.display_Name: '-'}}  </label>
                            </ion-col>
                          </ion-row>
                          <ion-row class="borderdown"></ion-row>
                        </div>
                      </ion-grid>
                    </ng-container>
                    <ng-container *ngIf="!bucket.machines?.length">
                      <ion-label class="no-machines-added">{{"No Machines Added"|translate}}</ion-label>
                    </ng-container>
                  </div>
                </ion-card>
              </div>
            </ion-card>
          </ng-container>

          <!-- Available Machines -->
          <div [ngStyle]="{'padding-top':allBucketLists?.length ? '10px' : '0px' }">
            <ion-card class="card-header" *ngIf="machineListInfo?.length && isMachineListPermission">
              <ng-container *ngIf="!isFromSAP">
                  <ion-button class="app-large-btn app-btn-margin add-library-machine" shape="round" fill="outline" color="primary"
                    (click)='addMachineFromLibrary()'>
                    {{'Add Machine From Library'|translate}}
                  </ion-button>
                  <ion-button class="app-large-btn app-btn-margin" shape="round" fill="outline" color="primary"
                    (click)='addNewMachine()'>
                    {{'Add New Machine'|translate}}
                  </ion-button>
                </ng-container>
              <ion-row class="mainlabel">
                <ion-col size='12'>
                  <ion-label class="titlelabel"> {{ 'Available Machines' | translate}}</ion-label>
                </ion-col>
              </ion-row>
              <ion-row class="mainlabel" *ngIf="machineListInfo?.length > 0">
                <ion-col size="12" *ngIf='machineListInfo?.length>1' (click)="toggleAllMachines()">
                  <ion-checkbox 
                    (keydown.enter)="toggleAllMachines()"
                    [checked]="isAllMachineCheckboxSelected"
                    [indeterminate]="isIndeterminate" mode="md">
                  </ion-checkbox>
                  <ion-label class="select-all-label">
                    {{ (isAllMachineCheckboxSelected ? 'deselect_all' : 'Select All') | translate}}
                  </ion-label>
                </ion-col>
              </ion-row>
              <ion-grid *ngIf="machineListViewType === 'grid-view'">
                <ion-row class="labelside scroll-element">
                  <ion-col size="3" *ngFor="let machine of machineListInfo">
                    <app-machine-card  *ngIf="!isLoading" 
                      [item]="machine" 
                      [showStatus]="true" 
                      [status]="machine.is_RA_Status" 
                      [showMore]="true"
                      [showCheckbox]="true" (deleteMachineCheckbox)="changeMachineCheckboxSelection($event)"
                      id="select_machines_card_{{machine.machine_Id}}" (click)="goToMachineDetails($event, machine)"
                      (checkMore)="machineMoreIcons($event, 'machine-specific-kebab-elipse', machine)">
                    </app-machine-card>
                  </ion-col>
                </ion-row>
              </ion-grid>
              <ion-grid *ngIf="machineListViewType === 'layout-view'">
                <ion-row class="labelside">
                  <ion-col>
                    <label class="lableFont">{{ 'Machine Name' | translate}}</label>
                  </ion-col>
                  <ion-col>
                    <label class="lableFont"> {{ 'Serial Number' | translate}}</label>
                  </ion-col>
                  <ion-col>
                    <label class="lableFont"> {{ 'Asset No.' | translate}}</label>
                  </ion-col>
                  <ion-col>
                    <label class="lableFont"> {{ 'Machine Type' | translate}}</label>
                  </ion-col>
                  <ion-col><label class="lableFont"> {{ 'Assigned Staff' | translate}}</label></ion-col>
                </ion-row>
                <ion-row class="borderdown"></ion-row>
                <div *ngFor="let machine of machineListInfo">
                  <ion-row class="labelside" *ngIf='machine.machine_Id!=="00000000-0000-0000-0000-000000000000"'
                    (click)="goToMachineDetails($event, machine)"
                    id="listView_bucket_available_machine_{{machine.machine_Id}}">
                    <ion-col>
                      <label class="lablemain">
                        {{machine.machine_Name}}
                      </label>
                    </ion-col>
                    <ion-col>
                      <label class="lableSub">{{machine.serial_Number ? machine.serial_Number : '-'}}</label>
                    </ion-col>
                    <ion-col>
                      <label class="lableSub"> {{machine.asset_Id ? machine.asset_Id : '-'}} </label>
                    </ion-col>
                    <ion-col>
                      <label class="lableSub"> {{machine.masterMachine?.machine_Type
                        ?machine.masterMachine?.machine_Type : '-'}} </label>
                    </ion-col>
                    <ion-col>
                      <label class="lableSub"> {{machine.assignedStaff && machine.assignedStaff.display_Name ?
                        machine.assignedStaff.display_Name
                        : '-'}} </label>
                    </ion-col>
                  </ion-row>
                  <ion-row class="borderdown"></ion-row>
                </div>
              </ion-grid>
            </ion-card>

            <!-- No Machines Available View -->
            <ion-card class="card-header" *ngIf="!machineListInfo?.length || !isMachineListPermission">
              <ng-container *ngIf="!isFromSAP && isMachineListPermission">
                <ion-button class="app-large-btn app-btn-margin add-library-machine" shape="round" fill="outline" color="primary"
                  (click)='addMachineFromLibrary()'>
                  {{'Add Machine From Library'|translate}}
                </ion-button>
                <ion-button class="app-large-btn app-btn-margin" shape="round" fill="outline" color="primary"
                  (click)='addNewMachine()'>
                  {{'Add New Machine'|translate}}
                </ion-button>
              </ng-container>
              <ion-row>
                <ion-col style="text-align: center;">
                  <img src="../../../assets/images/No data-cuate.svg" alt=""/>
                  <p class="no-machines-available" *ngIf="isMachineListPermission"> {{ 'No Machines Added' |
                    translate}}.</p>
                  <p class="no-machines-available" *ngIf="!isMachineListPermission">
                    {{ 'Sorry No permissions to view Machines' | translate}}.</p>
                </ion-col>
              </ion-row>
            </ion-card>
          </div>
        </div>

      </ng-container>
      <ion-card class="insideCard" *ngIf="!IsEmptyCard">
        <img class="centerImg" src="../../../assets/icon/Bigimage.svg" alt="">
        <div>
          <p class="textLabel">{{ 'Please Select Job Order & Service Product Id to View Data' | translate }}</p>
        </div>
      </ion-card>
    </div>

    <!-- Service Details Segment -->
  <div *ngSwitchCase="'service_details_segment'" class="margin-left-110">
    <ion-card class="service-details-card" [ngClass]="{ 'scroll-enabled': isFromSAP }" *ngIf="IsEmptyCard">
      <div #old *ngIf="isFromSAP">
        <div style="padding-left: 1em; ">
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-label class="textCol2" position="stacked"> {{ 'Offer Id' | translate}}</ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="textCol2" position="stacked"> {{ 'Project Id' | translate}}</ion-label>
              </ion-col>
              <ion-col></ion-col>
              <ion-col></ion-col>
            </ion-row>
          </ion-grid>
          <ion-grid>
            <ion-row style="margin-top:-8px">
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked">

                  {{serviceTabData?.erp_wbs_id?serviceTabData?.erp_wbs_id:serviceTabData?.erp_Wbs_Id?serviceTabData?.erp_Wbs_Id:serviceTabData.offerId}}
                </ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked">
                  {{projectList?.erp_Project_Id?projectList?.erp_Project_Id:serviceTabData.projectId}}
                </ion-label>
              </ion-col>
              <ion-col></ion-col>
              <ion-col></ion-col>
            </ion-row>
          </ion-grid>
        </div>
        <p class="rowborder"></p>
        <div style="padding-left: 1em;">
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-label class="textCol2" position=" stacked"> {{ 'Contact Person' | translate}}</ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="textCol2" position="stacked"> {{ 'Customer Name' | translate}}</ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="textCol2" position="stacked"> {{ 'Contact Email' | translate}}</ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="textCol2" position="stacked"> {{ 'Contact Number' | translate}}</ion-label>
              </ion-col>
            </ion-row>
          </ion-grid>
          <ion-grid>
            <ion-row style="margin-top:-8px">
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked">
                  {{serviceTabData.contactPerson || '-'}}
                </ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked">
                  {{serviceTabData.customerName || '-'}}
                </ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked">
                  {{serviceTabData.customerEmail || '-'}}</ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked">
                  {{serviceTabData.customerPhoneNumber || '-'}}</ion-label>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
        <div style="padding-left: 1em;">
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-label class="textCol2" position="stacked"> {{ 'Customer Address' | translate}}</ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="textCol2" position="stacked"> {{ 'Customer Id' | translate}}</ion-label>
              </ion-col>
              <ion-col></ion-col>
              <ion-col></ion-col>
            </ion-row>
          </ion-grid>
          <ion-grid style="margin-top:-7px">
            <ion-row style="margin-top:-8px">
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked">
                  {{serviceTabData.customerAddress || '-'}}
                </ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked">
                  {{serviceTabData.customerId || '-'}}</ion-label>
              </ion-col>
              <ion-col></ion-col>
              <ion-col></ion-col>
            </ion-row>
          </ion-grid>
        </div>
        <p class="rowborder"></p>
        <div style="padding-left: 1em;">
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-label class="textCol2" position=" stacked"> {{ 'Service Type' | translate }}</ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="textCol2" position="stacked"> {{ 'Service Location' | translate}}</ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="textCol2" position="stacked"> {{ 'Service Start Date' | translate}}</ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="textCol2" position="stacked"> {{ 'Service End Date' | translate}}</ion-label>
              </ion-col>
            </ion-row>
          </ion-grid>
          <ion-grid>
            <ion-row style="margin-top:-8px">
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked">
                  {{serviceTabData.serviceType || '-'}}
                </ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked"
                  tooltip="{{serviceTabData.serviceLocation || '-'}}" placement="bottom">
                  {{serviceTabData.serviceLocation | ellipsis: 40 || '-'}}
                </ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked">
                  {{ formatDisplayDate(serviceTabData.serviceStartDate) || '-' }}
                </ion-label>
              </ion-col>
              <ion-col>
                <ion-label class="labeltext" style="color:black!important" position="stacked">
                  {{ formatDisplayDate(serviceTabData.serviceEndDate) || '-' }}
                </ion-label>
              </ion-col>
            </ion-row>
          </ion-grid>

        </div>
        <div style="padding-left: 1em;">
          <ion-grid>
            <ion-row>
              <ion-col size="3">
                <ion-label class="textCol2" position="stacked"> {{ 'Region' | translate}}</ion-label>
              </ion-col>
              <ion-col size="9">
                <ion-label class="textCol2" position="stacked"> {{ 'Service Description' | translate}}</ion-label>
              </ion-col>              
            </ion-row>
          </ion-grid>
          <ion-grid style="margin-top:-7px">
            <ion-row style="margin-top:-8px">
              <ion-col size="3">
                <ion-label class="labeltext" style="color:black!important" position="stacked">
                  {{serviceTabData.region || '-'}}
                </ion-label>
              </ion-col>
              <ion-col size="9">
                <ion-label position="stacked">
                  <p class="desLabel">
                    {{serviceTabData.serviceDescription || '-'}}
                  </p>
                </ion-label>
              </ion-col>              
            </ion-row>
          </ion-grid>
        </div>
      </div>
      <!-- //////////////////////////// -->
      <div *ngIf="!isFromSAP" tabindex="-1" class="scroll-container">
        <ion-list>
          <ion-row>
            <ion-col size="12">
              <ion-icon tabindex="0" role="button" (keydown.enter)="editService(serviceDetails, 'serviceDetails')" name="create-outline" class="more-icon"
                *ngIf="!serviceDetails?.isEditServiceShow"
                (click)="editService(serviceDetails, 'serviceDetails')"
                tooltip="{{'Edit Service' | translate }}" placement="bottom">
              </ion-icon>
              <div *ngIf="serviceDetails?.isEditServiceShow">
                <ion-button fill="outline" shape="round" class="app-btn" [disabled]="isSaveDisabled"
                  (click)="isEditServiceSave(serviceDetails)">{{ 'Save' |
                  translate}}</ion-button>
                <ion-button fill="outline" shape="round" class="app-btn" (click)="editServiceCancel(serviceDetails)">{{
                  'Cancel' | translate}}</ion-button>
              </div>
            </ion-col>
          </ion-row>
        </ion-list>
            <ion-grid >
              <ion-row>
                <ion-col>
                  <ion-label class="textCol2" position="stacked"> {{ 'Offer Id' | translate}}</ion-label>
                </ion-col>
                <ion-col>
                  <ion-label class="textCol2" position="stacked"> {{ 'Project Id' | translate}}</ion-label>
                </ion-col>
                <ion-col></ion-col>
                <ion-col></ion-col>
              </ion-row>
            </ion-grid>
            <ion-grid>
              <ion-row>
                <ion-col>
                  <ion-label class="labeltext" position="stacked">
                    {{serviceDetails?.offerId || '-'}}
                  </ion-label>
                </ion-col>
                <ion-col>
                  <ion-label class="labeltext" position="stacked">
                    {{serviceDetails?.project_id || '-'}}
                  </ion-label>
                </ion-col>
                <ion-col></ion-col>
                <ion-col></ion-col>
              </ion-row>
            </ion-grid>
            <p class="rowborder"></p>
            <ion-grid class="service-details-paired-grid">
              <ion-row class="service-details-paired-row">
                <ion-col class="service-details-field">
                  <ion-label class="textCol2" position="stacked"> {{ 'Contact Person' | translate}}</ion-label>
                  <ion-label *ngIf="!serviceDetails?.isEditServiceShow" class="labeltext" position="stacked">
                    {{serviceDetails?.contact_person || '-'}}
                  </ion-label>
                  <ng-select *ngIf="serviceDetails?.isEditServiceShow" dropdownPosition="bottom" name="clientContactPerson" [clearable]="false"
                    bindLabel="display_Name" (change)="changeContactPerson($event)" required
                    [items]="(sharedService.customersInfo |async)?.contacts"
                    [(ngModel)]="serviceDetails.contact_person" #clientContactPerson="ngModel"
                    placeholder="{{ 'Select Contact Person' | translate }}">
                  </ng-select>
                </ion-col>
                <ion-col class="service-details-field">
                  <ion-label class="textCol2" position="stacked"> {{ 'Customer Name' | translate}}</ion-label>
                  <ion-label class="labeltext" position="stacked">
                    {{serviceDetails?.customer_name || '-'}}
                  </ion-label>
                </ion-col>
                <ion-col class="service-details-field">
                  <ion-label class="textCol2" position="stacked"> {{ 'Contact Email' | translate}}</ion-label>
                  <ion-label *ngIf="!serviceDetails?.isEditServiceShow" class="labeltext" position="stacked">
                    {{serviceDetails?.contact_email || '-' }}
                  </ion-label>
                  <ng-select *ngIf="serviceDetails?.isEditServiceShow" dropdownPosition="bottom" name="clientContactEmail" [clearable]="false"
                    bindLabel="email_Address" (change)="changeContactEmail($event)" required
                    [items]="(sharedService.customersInfo |async)?.contacts"
                    [(ngModel)]="serviceDetails.contact_email" #clientContactEmail="ngModel"
                    placeholder="{{ 'Select Contact Email' | translate }}">
                  </ng-select>
                </ion-col>
                <ion-col class="service-details-field">
                  <ion-label class="textCol2" position="stacked"> {{ 'Contact Number' | translate}}</ion-label>
                  <ion-label *ngIf="!serviceDetails?.isEditServiceShow" class="labeltext" position="stacked">
                    {{serviceDetails?.contact_phone_number || '-'}}</ion-label>
                  <ng-select *ngIf="serviceDetails?.isEditServiceShow" dropdownPosition="bottom" name="customerContact" [clearable]="false"
                    (change)="changeContactPhone($event)" bindLabel="phone_Number" required
                    [items]="(sharedService.customersInfo |async)?.contacts"
                    [(ngModel)]="serviceDetails.contact_phone_number" #customerContact="ngModel"
                    placeholder="{{ 'select_contact' | translate }}">
                  </ng-select>
                </ion-col>
              </ion-row>
            </ion-grid>
            <ion-grid class="service-details-paired-grid">
              <ion-row class="service-details-paired-row">
                <ion-col class="service-details-field">
                  <ion-label class="textCol2" position="stacked"> {{ 'Customer Address' | translate}}</ion-label>
                  <ion-label class="labeltext" position="stacked">
                    {{serviceDetails?.customer_address || '-'}}
                  </ion-label>
                </ion-col>
                <ion-col class="service-details-field">
                  <ion-label class="textCol2" position="stacked"> {{ 'Customer Id' | translate}}</ion-label>
                  <ion-label class="labeltext" position="stacked">
                    {{serviceDetails?.customer_id || '-'}}</ion-label>
                </ion-col>
                <ion-col></ion-col>
                <ion-col></ion-col>
              </ion-row>
            </ion-grid>
            <p class="rowborder"></p>
            <ion-grid class="service-details-paired-grid">
              <ion-row class="service-details-paired-row">
                <ion-col class="service-details-field">
                  <ion-label class="textCol2" position="stacked"> {{ 'Service Type' | translate}}</ion-label>
                  <ion-label class="labeltext" position="stacked">
                    {{serviceDetails?.service_type || '-'}}
                  </ion-label>
                </ion-col>
                <ion-col class="service-details-field">
                  <ion-label class="textCol2" position="stacked"> {{ 'Service Location' | translate}}</ion-label>
                  <ion-label class="labeltext" position="stacked"
                    tooltip="{{serviceDetails?.service_location || '-'}}" placement="top">
                    {{serviceDetails?.service_location | ellipsis: 40 || '-'}}
                  </ion-label>
                </ion-col>
                <ion-col class="service-details-field">
                  <ion-label class="textCol2" position="stacked"> {{ 'Service Start Date' | translate}}</ion-label>
                  <ion-label class="labeltext" position="stacked">
                    {{ formatDisplayDate(serviceDetails?.start_date) || '-' }}
                  </ion-label>
                </ion-col>
                <ion-col class="service-details-field">
                  <ion-label class="textCol2" position="stacked"> {{ 'Service End Date' | translate}}</ion-label>
                  <ion-label class="labeltext" position="stacked">
                    {{ formatDisplayDate(serviceDetails?.end_date) || '-' }}
                  </ion-label>
                </ion-col>
              </ion-row>
            </ion-grid>
            <ion-grid class="service-details-paired-grid">
              <ion-row class="service-details-paired-row">
                <ion-col size="3" class="service-details-field">
                  <ion-label class="textCol2" position="stacked"> {{ 'Region' | translate}}</ion-label>
                  <ion-label class="labeltext" position="stacked">
                    {{serviceDetails?.service_region || '-'}}
                  </ion-label>
                </ion-col>
                <ion-col size="9" class="service-details-field service-description-col">
                  <ion-label class="textCol2" position="stacked"> {{ 'Service Description' | translate}}</ion-label>
                  <ion-label *ngIf="!serviceDetails?.isEditServiceShow" position="stacked">
                    <p class="desLabel">
                      {{serviceDetails?.service_description || '-'}}
                    </p>
                  </ion-label>
                  <div *ngIf="serviceDetails?.isEditServiceShow" class="service-description-edit-stack">
                    <div class="service-description-edit-item">
                      <app-ai-writing-field-shell
                        class="service-description-resizable"
                        name="serviceDescription"
                        placeholder="{{ 'Service Description' | translate }}"
                        [(ngModel)]="serviceDetails.service_description"
                        (ngModelChange)="updateServiceDescriptionCharCount($event)"
                        (commit)="onServiceDescriptionBlur()"
                        [maxlength]="1000" [rows]="4"
                        fieldContextType="service-description" [historyKey]="'service-description::' + selected_service_Id">
                      </app-ai-writing-field-shell>
                    </div>
                    <ion-text class="char-counter" [ngClass]="{'danger': serviceDescriptionLength > 1000}">
                      {{ serviceDescriptionLength }}/1000
                    </ion-text>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
      </div>
    </ion-card>
      <ion-card class="insideCard" *ngIf="!IsEmptyCard">
        <img class="centerImg" src="../../../assets/icon/Bigimage.svg" alt="">
        <div>
          <p class="textLabel">{{ 'Please Select Job Order & Service Product Id to View Data' | translate }}</p>
        </div>
      </ion-card>
    </div>

    <!-- Service Roadmap Details Segment -->
    <div *ngSwitchCase="'service_roadmap_details_segment'">
      <app-grid [ngClass]="isRoadmapGridDisplayed ? 'show' : 'hide' " class="service-roadmap-grid margin-left-112" [columns]="roadmapGridColumnDefs" [data]="this.sharedService.selectedServiceRoadmapsList" [gridConfigItems]="roadmapGridConfigItems" (onBtnClick)="configureRoadmaps()"
        (onCellClick)="fnOnGridCellClick($event)" [showKebabIcon]="false">
      </app-grid>
      <ng-container *ngIf="!isRoadmapGridDisplayed && !isRoadmapHistoryDisplayed">
        <div class="roadmap-view-margin">
        <roadmap-view-create 
          [sectionList]="sectionList"
          [sectionDetails]="sectionDetails"
          [project_id]="project_Id"
          [serviceMachineId]="serviceMachineId"
          [roadmapId]="roadmapId"
          [roadmapName]="roadmapName"
          [isCustom]="isCustom"
          [isMachineBased]="false"
          [roadmapList]="this.sharedService.selectedServiceRoadmapsList"
          (exitEvent)="fnExitEvent($event)"></roadmap-view-create>
        </div>
      </ng-container>
      <ng-container  *ngIf="isRoadmapHistoryDisplayed && !isRoadmapGridDisplayed">
        <app-roadmap-history 
                       [historyData]="historyData" 
                       (exitEvent)="fnExitEvent($event)"></app-roadmap-history>
      </ng-container>
    </div>
    <!-- Log Actual Hours Segemnt -->
    <div *ngSwitchCase="'log_actual_hours_segment'" class="margin-left-110">
      <ion-card class="insideCardData" *ngIf="IsEmptyCard" style="width: 96.5%;">
        <div class="sticky">
        </div>
        <div>
          <div *ngFor="let eachActualHour of logActualHoursInfo;let i=index">
            <ion-card-content>
              <ion-item lines='none' class="log-actual-hours-accordian" (click)='openMachineDetails(eachActualHour)'>
                <ion-label>{{'Machine Name' | translate}} : {{eachActualHour.machinename}}</ion-label>
                  <ion-icon name="chevron-down-outline" slot="end" *ngIf="!eachActualHour?.open"></ion-icon>
                  <ion-icon name="chevron-up-outline" slot="end" *ngIf="eachActualHour?.open"></ion-icon>
              </ion-item>
              <ion-list class="list-view " *ngIf="eachActualHour.open">
                  <div class="table-container scrollVertical">
                    <table class="table">
                      <thead>
                        <th class="text th"> {{ 'Actual Hours' |translate}}</th>
                        <th class="text th">{{ 'Comments' | translate}}</th>
                        <th class="text th">{{ 'User Name' | translate}}</th>
                        <th class="text th">{{ 'Created Date' | translate}}</th>
                        <th class="text th icon-align">{{'Actions'| translate}}</th>
                      </thead>
                      <tr *ngFor="let actualHours of actualHoursList">
                        <td class="td">
                           <ng-container *ngIf="!actualHours.edit">
                            {{actualHours.actualHours ? actualHours.actualHours : '-'}}
                          </ng-container>
                          <ng-container *ngIf="actualHours.edit">
                            <ion-input type="text" inputmode="decimal" placeholder="{{ 'enter_actual_hours' | translate }}"
                              class="log-actual-hours-input input-textarea" [ngClass]="actualHours.isActualHourExceedError ? 'log-actual-hours-input-error' : ''"
                              (ionInput)="onInputChange($event)" (ionBlur)="onBlur($event)" (ionChange)="editLogActualHoursValues($event, actualHours, 'edit-actual')">
                            </ion-input>
                          </ng-container>
                          <ion-label *ngIf="actualHours.enableShowWarning" class="error-text">{{ 'actual_hours_exceeding_calculated_hours' | translate }}</ion-label>
                        </td>
                        <td class="td">
                          <ng-container *ngIf="!actualHours.edit">
                            {{actualHours.comments ? actualHours.comments : '-'}}
                          </ng-container>
                          <ng-container *ngIf="actualHours.edit">
                            <ion-textarea rows="2" class="input-textarea" cols="20" placeholder="{{ 'enter_comments' | translate }}"
                              (ionChange)="editLogActualHoursValues($event, actualHours, 'edit-comment')"></ion-textarea>
                          </ng-container>
                        </td>
                        <td class="td">{{actualHours.userName}}</td>
                        <td class="td">{{actualHours.createdAt | date: 'dd-MM-yyyy HH:mm'}}</td>
                        <td class="td icon-align">
                          <span *ngIf="!actualHours.edit">
                            <ion-icon name="trash-outline" size="small" color="primary" (click)="deleteLogActualHours(eachActualHour,actualHours,'delete')"></ion-icon>
                          </span>
                          <span *ngIf="actualHours.edit" class="actual-hours-span">
                            <ion-button [disabled]="isActualHoursSaveDisabled(actualHours)" class="app-btn save-actual-hours" shape="round" fill="outline" color="primary" (click)="saveLogActualHours(eachActualHour,'add')">
                              {{'Save'|translate}}
                            </ion-button>
                          </span>
                        </td>
                      </tr>
                    </table>
                    
                  </div>
                <ion-button fill="outline" class="add-new-btn" shape="round"(click)="addNewRow(eachActualHour)">
                  <ion-icon name="add-circle-outline"  size="small" color="primary"></ion-icon>&nbsp; {{'Add'|translate}}
                </ion-button>
              </ion-list>
            </ion-card-content>
          </div>
        </div>
        <div *ngIf="this.machineListInfo.length === 0">
          <img class="img-center" src="/assets/images/Group 20605.svg" alt="">
          <ion-label class="no-data-css"> {{ 'No Machines Added' | translate}}</ion-label>
        </div>
      </ion-card>
      <ion-card class="insideCard" *ngIf="!IsEmptyCard">
        <img class="centerImg" src="../../../assets/icon/Bigimage.svg" alt="">
        <div>
          <p class="textLabel">{{ 'Please Select Job Order & Service Product Id to View Data' | translate }}</p>
        </div>
      </ion-card>
    </div>

    <!-- Overview Segment -->
    <div *ngSwitchCase="'overview_segment'" class="margin-left-110">
      <app-project-items-view [gridData]="projectOverViewLists"></app-project-items-view>
    </div>

    <!-- Status Segment -->
    <div *ngSwitchCase="'status_segment'" class="margin-left-110">
      <ion-card class="insideCardData" *ngIf="IsEmptyCard" style="width: 92%;">
        <div class="scrollelement">
          <ion-grid class="status-container">
            <ion-row>
              <ion-col size="12">
                <ul class="progressbar">
                  <li [ngClass]="step.isdone ? 'done-stepper' : ''" *ngFor="let step of statusStepperData">
                    <div class="stepper-label">{{step.name}}</div>
                  </li>
                </ul>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </ion-card>
      <ion-card class="insideCard" *ngIf="!IsEmptyCard">
        <img class="centerImg" src="../../../assets/icon/Bigimage.svg" alt="">
        <div>
          <p class="textLabel">{{ 'Please Select Job Order & Service Product Id to View Data' | translate }}</p>
        </div>
      </ion-card>
    </div>
  </div>
</ion-content>